module.exports = __webpack_public_path__ + "static/media/F15-128695-Consilient-Health-Altavita-New-GP-Consult.7ce0aeb6.gif";